exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.scrolllll[data-v-31ef0e78] {\r\n    max-height: 350px;\r\n    overflow-y: auto;\n}\r\n", ""]);

// exports
